import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import da from './locales/da.json';
import en from './locales/en.json';
import hu from './locales/hu.json';
import ro from './locales/ro.json';

/**
 * i18next init. Language resources are bundled (not lazy-loaded) since the
 * app is small and this avoids a flash-of-untranslated-content on switch.
 * The active language is chosen by `LanguageProvider` (see
 * `src/contexts/LanguageContext.tsx`), which also persists the signed-in
 * user's choice — this file only wires up the translation engine itself.
 */
void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    da: { translation: da },
    ro: { translation: ro },
    hu: { translation: hu },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
